// // import React, { useState, useEffect } from "react";
// // import { Formik, Field, Form } from "formik";
// // import {
// //   InputGroup,
// //   FieldWrappers,
// //   Label,
// //   SubmitBtn,
// //   SideCancelBtn,
// //   Wrapper,
// //   ScrollableContent,
// //   ActionSection,
// //   CombineInputGroup,
// //   RupeeIcon,
// //   MobileIcon,
// //   ModalSubHeading,
// //   ModalHeading,
// // } from "../../Styles/InputStyles";
// // import { MdClose } from "react-icons/md";
// // import tw from "tailwind-styled-components";
// // import * as Yup from "yup";
// // import MenuItem from "@mui/material/MenuItem";
// // import Select from "@mui/material/Select";
// // import DatePicker from "react-datepicker";
// // import "react-datepicker/dist/react-datepicker.css";
// // import { FaRegCalendar } from "react-icons/fa";
// // import moment from "moment";
// // import { useSelector } from "react-redux";
// // import { generateMonthOptions } from "../../../helpers";

// // // Step 1 Validation Schema
// // const stepOneSchema = Yup.object().shape({
// //   landlordName: Yup.string()
// //     .matches(/^[A-Za-z0-9. - ]+$/, "Only alphabets, numbers, spaces and hyphens are allowed")
// //     .min(3, "Landlord name must be at least 3 characters long")
// //     .required("Landlord name is required"),
// //   mobile: Yup.string()
// //     .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits")
// //     .required("Mobile number is required"),
// //   rentPayable: Yup.number()
// //     .min(1000, "Rent payable must be at least ₹1,000")
// //     .max(2000000, "Rent payable cannot exceed ₹20,00,000")
// //     .required("Rent payable is required"),
// //   securityDeposit: Yup.number()
// //     .min(0, "Security deposit cannot be negative")
// //     .max(5000000, "Security deposit cannot exceed ₹50,00,000")
// //     .required("Security deposit is required"),
// //   agreementStartDate: Yup.date().required("Agreement start date is required"),
// //   agreementEndDate: Yup.date()
// //     .min(Yup.ref("agreementStartDate"), "End date must be after start date")
// //     .required("Agreement end date is required"),
// //   rentDate: Yup.date().required("Rent payment date is required"),
// // });

// // // Step 2 Validation Schema
// // const stepTwoSchema = Yup.object().shape({

// //   noticePeriod: Yup.number()
// //     .min(1, "Notice period must be at least 1 month")
// //     .max(12, "Notice period cannot exceed 12 months")
// //     .required("Notice period is required"),
// //   incrementMonth: Yup.number()
// //     .typeError("Increment month must be a number")
// //     .integer("Increment month must be a whole number")
// //     .min(1, "Increment month must be at least 1 month")
// //     .max(60, "Increment month cannot exceed 60 months"),
// //     //.required("Increment month is required"),
// //   lockInPeriod: Yup.number()
// //     .typeError("Lock-in period must be a number")
// //     .integer("Lock-in period must be a whole number")
// //     .min(1, "Lock-in period must be at least 1 month")
// //     .max(36, "Lock-in period cannot exceed 36 months")
// //     .required("Lock-in period is required"),
// //   incrementType: Yup.string().nullable(),
// //   rentCollectionType: Yup.string().nullable(),
// //   incrementValue: Yup.number()
// //     .nullable()
// //     .when("incrementType", {
// //       is: (type) => !!type,
// //       then: (schema) =>
// //         schema
// //           .required("Rent increment value is required")
// //           .min(0, "Value cannot be negative")
// //           .when("incrementType", {
// //             is: "2",
// //             then: (s) => s.max(100, "Percentage cannot exceed 100%"),
// //             otherwise: (s) =>
// //               s.max(1000000, "Flat increment cannot exceed ₹10,00,000"),
// //           }),
// //       otherwise: (schema) => schema.notRequired(),
// //     }),
// // });

// // const CustomDateInput = React.forwardRef(({ value, onClick, error, placeholder }, ref) => {
// //   return (
// //     <div
// //       className={`flex items-center text-sm border rounded-md h-11 px-3 cursor-pointer ${error ? "border-rose-400" : "border-gray-300"
// //         }`}
// //       onClick={onClick}
// //       ref={ref}
// //     >
// //       <span className={`flex-1 ${value ? "text-gray-800" : "text-gray-400"}`}>
// //         {value || placeholder}
// //       </span>
// //       <FaRegCalendar className="text-gray-400" />
// //     </div>
// //   );
// // });

// // const EditLandlordLeaseDetails = ({
// //   editLandlordMutate,
// //   editLandlordLoading,
// //   handleClose,
// //   leaseData,
// // }) => {
// //   const [currentStep, setCurrentStep] = useState(1);
// //   const [formData, setFormData] = useState({
// //     landlordName: "",
// //     mobile: "",
// //     rentPayable: "",
// //     securityDeposit: "",
// //     agreementStartDate: null,
// //     agreementEndDate: null,
// //     rentDate: null,
// //     noticePeriod: "",
// //     incrementMonth: "",
// //     lockInPeriod: "",
// //     incrementType: "",
// //     incrementValue: "",
// //     rentCollectionType: "",
// //   });

// //   const user = useSelector((state) => state.UserReducer.user);

// //   useEffect(() => {
// //     if (leaseData) {
// //       setFormData({
// //         landlordName: leaseData.landlordName || "",
// //         mobile: leaseData.landlordMobile || "",
// //         rentPayable: leaseData.rent || "",
// //         securityDeposit: leaseData.security || "",
// //         agreementStartDate: leaseData.startDate
// //           ? moment(leaseData.startDate).format("YYYY-MM-DD")
// //           : null,
// //         agreementEndDate: leaseData.endDate
// //           ? moment(leaseData.endDate).format("YYYY-MM-DD")
// //           : null,
// //         rentDate: leaseData.rentDate
// //           ? moment(leaseData.rentDate).format("YYYY-MM-DD")
// //           : null,
// //         noticePeriod: leaseData.notice || "",
// //         incrementMonth: leaseData.incrementMonth || "",
// //         lockInPeriod: leaseData.lockInPeriod || "",
// //         incrementType: leaseData.incrementType?.toString() || "",
// //         incrementValue: leaseData.incrementValue || "",
// //         rentCollectionType: leaseData.rentCollectionType?.toString() || ""
// //       });
// //     }
// //   }, [leaseData]);

// //   const [height, setHeight] = useState(window.innerHeight);

// //   useEffect(() => {
// //     const handleResize = () => {
// //       setHeight(window.innerHeight);
// //     };

// //     window.addEventListener("resize", handleResize);
// //     handleResize();

// //     return () => {
// //       window.removeEventListener("resize", handleResize);
// //     };
// //   }, []);

// //   const handleStepOneSubmit = (values) => {
// //     setFormData(prev => ({
// //       ...prev,
// //       ...values
// //     }));
// //     setCurrentStep(2);
// //   };

// //   const handleStepTwoSubmit = (values) => {
// //     const combinedValues = {
// //       ...formData,
// //       ...values
// //     };

// //     const formattedValues = {
// //       name: combinedValues.landlordName,
// //       mobile: combinedValues.mobile,
// //       rent: Number(combinedValues.rentPayable),
// //       security: Number(combinedValues.securityDeposit),
// //       startDate: combinedValues.agreementStartDate,
// //       endDate: combinedValues.agreementEndDate,
// //       rentDate: combinedValues.rentDate,
// //       notice: combinedValues.noticePeriod,
// //       propId: leaseData.propId,
// //       incrementType: combinedValues.incrementType,
// //       incrementValue: Number(combinedValues.incrementValue) || 0,
// //       incrementMonth: Number(combinedValues.incrementMonth),
// //       lockInPeriod: Number(combinedValues.lockInPeriod),
// //       rentCollectionType: Number(combinedValues.rentCollectionType),
// //       landlordId: leaseData.landlordId
// //     };

// //     editLandlordMutate(formattedValues);
// //   };

// //   const handleBackToStepOne = () => {
// //     setCurrentStep(1);
// //   };

// //   const formatCurrency = (value) => {
// //     if (!value && value !== 0) return "";
// //     const numValue = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : value;
// //     if (isNaN(numValue)) return "";
// //     return new Intl.NumberFormat("en-IN").format(numValue);
// //   };

// //   const parseCurrency = (value) => {
// //     return value.replace(/,/g, "");
// //   };

// //   const getIncrementValueDisplay = (value, incrementType) => {
// //     if (!value && value !== 0) return "";

// //     if (incrementType === "1") {
// //       return value.toString();
// //     } else {
// //       return formatCurrency(value);
// //     }
// //   };

// //   const StepOneForm = () => (
// //     <Formik
// //       initialValues={formData}
// //       onSubmit={handleStepOneSubmit}
// //       validationSchema={stepOneSchema}
// //       enableReinitialize
// //     >
// //       {({
// //         values,
// //         setFieldValue,
// //         errors,
// //         touched,
// //         handleChange,
// //         handleBlur,
// //       }) => (
// //         <Form>
// //           <ModalSubHeading>Step 1</ModalSubHeading>
// //           <ModalHeading>Basic Details</ModalHeading>
// //           <ScrollableContent className="max-h-[calc(100dvh-150px)]">
// //             <Wrapper>
// //               <InputGroup>
// //                 <Label htmlFor="landlordName">Landlord Name *</Label>
// //                 <FieldWrappers>
// //                   <Field
// //                     type="text"
// //                     name="landlordName"
// //                     id="landlordName"
// //                     autoComplete="off"
// //                     placeholder="Enter landlord name"
// //                   />
// //                 </FieldWrappers>
// //                 {errors.landlordName && touched.landlordName && (
// //                   <ErrorMessage>{errors.landlordName}</ErrorMessage>
// //                 )}
// //               </InputGroup>

// //               {/* Mobile Number */}
// //               <InputGroup>
// //                 <Label htmlFor="mobile">Mobile Number *</Label>
// //                 <FieldWrappers>
// //                   <MobileIcon />
// //                   <Field
// //                     type="text"
// //                     name="mobile"
// //                     id="mobile"
// //                     autoComplete="off"
// //                     maxLength={10}
// //                     placeholder="Enter 10-digit mobile number"
// //                     className="w-full pl-5"
// //                   />
// //                 </FieldWrappers>
// //                 {errors.mobile && touched.mobile && (
// //                   <ErrorMessage>{errors.mobile}</ErrorMessage>
// //                 )}
// //               </InputGroup>

// //               <CombineInputGroup className="gap-4 md:gap-0">
// //                 {/* Rent Payable */}
// //                 <InputGroup>
// //                   <Label htmlFor="rentPayable">Rent Payable *</Label>
// //                   <FieldWrappers>
// //                     <RupeeIcon />
// //                     <Field
// //                       type="text"
// //                       name="rentPayable"
// //                       id="rentPayable"
// //                       autoComplete="off"
// //                       placeholder="Enter rent amount"
// //                       value={formatCurrency(values.rentPayable)}
// //                       onChange={(e) => {
// //                         const rawValue = parseCurrency(e.target.value);
// //                         if (rawValue === "" || /^\d+$/.test(rawValue)) {
// //                           setFieldValue("rentPayable", rawValue);
// //                         }
// //                       }}
// //                       className="w-full pl-5"
// //                     />
// //                   </FieldWrappers>
// //                   {errors.rentPayable && touched.rentPayable && (
// //                     <ErrorMessage>{errors.rentPayable}</ErrorMessage>
// //                   )}
// //                   <div className="text-xs text-gray-500 mt-1">
// //                     Min: ₹1,000 | Max: ₹20,00,000
// //                   </div>
// //                 </InputGroup>

// //                 {/* Security Deposit */}
// //                 <InputGroup>
// //                   <Label htmlFor="securityDeposit">
// //                     Security Deposit *
// //                   </Label>
// //                   <FieldWrappers className="w-full">
// //                     <RupeeIcon />
// //                     <Field
// //                       type="text"
// //                       name="securityDeposit"
// //                       id="securityDeposit"
// //                       autoComplete="off"
// //                       placeholder="Enter security amount"
// //                       value={formatCurrency(values.securityDeposit)}
// //                       onChange={(e) => {
// //                         const rawValue = parseCurrency(e.target.value);
// //                         if (rawValue === "" || /^\d+$/.test(rawValue)) {
// //                           setFieldValue("securityDeposit", rawValue);
// //                         }
// //                       }}
// //                       className="w-full pl-5"
// //                     />
// //                   </FieldWrappers>
// //                   {errors.securityDeposit &&
// //                     touched.securityDeposit && (
// //                       <ErrorMessage>
// //                         {errors.securityDeposit}
// //                       </ErrorMessage>
// //                     )}
// //                   <div className="text-xs text-gray-500 mt-1">
// //                     Min: ₹0 | Max: ₹50,00,000
// //                   </div>
// //                 </InputGroup>
// //               </CombineInputGroup>

// //               {/* Agreement Start Date */}
// //               <CombineInputGroup className="gap-4 md:gap-0">
// //                 <InputGroup>
// //                   <Label htmlFor="agreementStartDate">
// //                     Agreement Start Date *
// //                   </Label>
// //                   {/* <CalenderFieldWrappers> */}
// //                   <DatePicker
// //                     selected={values.agreementStartDate ? new Date(values.agreementStartDate) : null}
// //                     // selected={values.agreementStartDate}
// //                     onChange={(date) =>
// //                       setFieldValue(
// //                         "agreementStartDate",
// //                         moment(date).format("YYYY-MM-DD")
// //                       )
// //                     }
// //                     customInput={
// //                       <CustomDateInput
// //                         placeholder="Select start date"
// //                         error={touched.agreementStartDate && errors.agreementStartDate}
// //                       />
// //                     }
// //                     dateFormat="yyyy-MM-dd"
// //                     showMonthDropdown
// //                     showYearDropdown
// //                     dropdownMode="select"
// //                   />
// //                   {/* </CalenderFieldWrappers> */}
// //                   {errors.agreementStartDate &&
// //                     touched.agreementStartDate && (
// //                       <ErrorMessage>
// //                         {errors.agreementStartDate}
// //                       </ErrorMessage>
// //                     )}
// //                 </InputGroup>

// //                 {/* Agreement End Date */}
// //                 <InputGroup>
// //                   <Label htmlFor="agreementEndDate">
// //                     Agreement End Date *
// //                   </Label>
// //                   {/* <CalenderFieldWrappers> */}
// //                   <DatePicker
// //                     // selected={values.agreementEndDate}
// //                     selected={values.agreementEndDate ? new Date(values.agreementEndDate) : null}
// //                     onChange={(date) =>
// //                       setFieldValue(
// //                         "agreementEndDate",
// //                         moment(date).format("YYYY-MM-DD")
// //                       )
// //                     }
// //                     customInput={
// //                       <CustomDateInput
// //                         placeholder="Select end date"
// //                         error={touched.agreementEndDate && errors.agreementEndDate}
// //                       />
// //                     }
// //                     // selectsEnd
// //                     // minDate={values.agreementStartDate}
// //                     minDate={values.agreementStartDate ? new Date(values.agreementStartDate) : null}
// //                     dateFormat="yyyy-MM-dd"
// //                     // showIcon
// //                     // icon={
// //                     //   <FaRegCalendar className="text-gray-400 text-xs mt-0.5" />
// //                     // }
// //                     showMonthDropdown
// //                     showYearDropdown
// //                     dropdownMode="select"
// //                   // placeholderText="Select end date"
// //                   // className="cursor-pointer outline-none border-none focus:ring-0"
// //                   // autoComplete="off"
// //                   // onFocus={(e) => e.target.blur()}
// //                   />
// //                   {/* </CalenderFieldWrappers> */}
// //                   {errors.agreementEndDate &&
// //                     touched.agreementEndDate && (
// //                       <ErrorMessage>
// //                         {errors.agreementEndDate}
// //                       </ErrorMessage>
// //                     )}
// //                 </InputGroup>
// //               </CombineInputGroup>

// //               {/* Rent Payment Date */}
// //               <InputGroup>
// //                 <Label htmlFor="rentDate">
// //                   Rent Payment Date *
// //                 </Label>
// //                 {/* <CalenderFieldWrappers> */}
// //                 <DatePicker
// //                   // selected={values.rentDate}
// //                   selected={values.rentDate ? new Date(values.rentDate) : null}
// //                   onChange={(date) =>
// //                     setFieldValue(
// //                       "rentDate",
// //                       moment(date).format("YYYY-MM-DD")
// //                     )
// //                   }
// //                   customInput={
// //                     <CustomDateInput
// //                       placeholder="Select rent date"
// //                       error={touched.rentDate && errors.rentDate}
// //                     />
// //                   }
// //                   // selectsStart
// //                   dateFormat="yyyy-MM-dd"
// //                   // showIcon
// //                   // icon={
// //                   //   <FaRegCalendar className="text-gray-400 text-xs mt-0.5" />
// //                   // }
// //                   showMonthDropdown
// //                   showYearDropdown
// //                   dropdownMode="select"
// //                 // placeholderText="Select rent date"
// //                 // className="cursor-pointer outline-none border-none focus:ring-0"
// //                 // autoComplete="off"
// //                 // onFocus={(e) => e.target.blur()}
// //                 />
// //                 {/* </CalenderFieldWrappers> */}
// //                 {errors.rentDate &&
// //                   touched.rentDate && (
// //                     <ErrorMessage>
// //                       {errors.rentDate}
// //                     </ErrorMessage>
// //                   )}
// //               </InputGroup>

// //             </Wrapper>
// //           </ScrollableContent>
// //           <ActionSection>
// //             <SideCancelBtn type="button" onClick={handleClose}>
// //               Cancel
// //             </SideCancelBtn>
// //             <SubmitBtn type="submit">
// //               Next
// //             </SubmitBtn>
// //           </ActionSection>
// //         </Form>
// //       )}
// //     </Formik>
// //   );

// //   const StepTwoForm = () => (
// //     <Formik
// //       initialValues={{
// //         //rentDate: formData.rentDate,
// //         noticePeriod: formData.noticePeriod,
// //         incrementMonth: formData.incrementMonth,
// //         lockInPeriod: formData.lockInPeriod,
// //         incrementType: formData.incrementType,
// //         incrementValue: formData.incrementValue,
// //         rentCollectionType: formData.rentCollectionType
// //       }}
// //       onSubmit={handleStepTwoSubmit}
// //       validationSchema={stepTwoSchema}
// //       enableReinitialize
// //     >
// //       {({
// //         values,
// //         setFieldValue,
// //         errors,
// //         touched,
// //       }) => (
// //         <Form>
// //           <ModalSubHeading>Step 2</ModalSubHeading>
// //           <ModalHeading>Additional Details</ModalHeading>
// //           <ScrollableContent className="max-h-[calc(100dvh-140px)]">
// //             <Wrapper>

// //               {/* Notice Period */}
// //               <InputGroup>
// //                 <Label htmlFor="noticePeriod">Notice Period *</Label>
// //                 <Select
// //                   name="noticePeriod"
// //                   id="noticePeriod"
// //                   className="w-full px-2"
// //                   value={values.noticePeriod}
// //                   onChange={(e) => {
// //                     setFieldValue("noticePeriod", e.target.value);
// //                   }}
// //                   style={{ height: "46px" }}
// //                   displayEmpty
// //                 >
// //                   <MenuItem value="" disabled>
// //                     Select notice period
// //                   </MenuItem>
// //                   {generateMonthOptions.map((option) => (
// //                     <MenuItem key={option.value} value={option.value}>
// //                       {option.label}
// //                     </MenuItem>
// //                   ))}
// //                 </Select>
// //                 {errors.noticePeriod && touched.noticePeriod && (
// //                   <ErrorMessage>{errors.noticePeriod}</ErrorMessage>
// //                 )}
// //               </InputGroup>

// //               <InputGroup>
// //                 <Label htmlFor="rentCollectionType">Rent Collection Type *</Label>
// //                 <Select
// //                   name="rentCollectionType"
// //                   id="rentCollectionType"
// //                   className="w-full px-2"
// //                   value={values.rentCollectionType || ""}
// //                   onChange={(e) => {
// //                     setFieldValue("rentCollectionType", e.target.value);

// //                   }}
// //                   style={{ height: "46px" }}
// //                   displayEmpty
// //                 >
// //                   <MenuItem value="" disabled>
// //                     Rent Collection Type
// //                   </MenuItem>
// //                   <MenuItem value="1">Advance Rent</MenuItem>
// //                   <MenuItem value="2">Month-End Rent</MenuItem>
// //                 </Select>
// //                 {errors.rentCollectionType && touched.rentCollectionType && (
// //                   <ErrorMessage>{errors.rentCollectionType}</ErrorMessage>
// //                 )}
// //               </InputGroup>

// //               {/* Rent Increment */}
// //               <CombineInputGroup className="gap-4 md:gap-0">
// //                 {/* Increment Type */}
// //                 <InputGroup>
// //                   <Label htmlFor="incrementType">Rent Increment Type</Label>
// //                   <Select
// //                     name="incrementType"
// //                     id="incrementType"
// //                     className="w-full px-2"
// //                     value={values.incrementType || ""}
// //                     onChange={(e) => {
// //                       setFieldValue("incrementType", e.target.value);
// //                       setFieldValue("incrementValue", "");
// //                     }}
// //                     style={{ height: "46px" }}
// //                     displayEmpty
// //                   >
// //                     <MenuItem value="" disabled>
// //                       Select increment type
// //                     </MenuItem>
// //                     <MenuItem value="1">Flat Amount (₹)</MenuItem>
// //                     <MenuItem value="2">Percentage (%)</MenuItem>
// //                   </Select>
// //                   {errors.incrementType && touched.incrementType && (
// //                     <ErrorMessage>{errors.incrementType}</ErrorMessage>
// //                   )}
// //                 </InputGroup>

// //                 {/* Increment Value */}
// //                 <InputGroup>
// //                   <Label htmlFor="incrementValue">Increment Value</Label>
// //                   <FieldWrappers className={
// //                     touched.incrementValue && errors.incrementValue
// //                       ? "border-rose-400"
// //                       : "border-gray-300"
// //                   }>
// //                     {values.incrementType === "2" ? (
// //                       <>
// //                         <Field
// //                           type="number"
// //                           name="incrementValue"
// //                           id="incrementValue"
// //                           min="0"
// //                           max="100"
// //                           placeholder="Enter % increase"
// //                           className="w-full pl-2"
// //                           value={values.incrementValue || ""}
// //                           onChange={(e) => {
// //                             setFieldValue("incrementValue", e.target.value);
// //                           }}
// //                         />
// //                         <span className="text-gray-500 pr-2">%</span>
// //                       </>
// //                     ) : values.incrementType === "1" ? (
// //                       <>
// //                         <RupeeIcon />
// //                         <Field
// //                           type="text"
// //                           name="incrementValue"
// //                           id="incrementValue"
// //                           placeholder="Enter amount"
// //                           value={getIncrementValueDisplay(values.incrementValue, values.incrementType)}
// //                           onChange={(e) => {
// //                             const rawValue = parseCurrency(e.target.value);
// //                             if (rawValue === "" || /^\d+$/.test(rawValue)) {
// //                               setFieldValue("incrementValue", rawValue);
// //                             }
// //                           }}
// //                           className="w-full pl-5"
// //                         />
// //                       </>
// //                     ) : (
// //                       <span className="text-gray-400 text-sm pl-2 italic">
// //                         Select increment type first
// //                       </span>
// //                     )}
// //                   </FieldWrappers>
// //                   {/* {errors.incrementValue && touched.incrementValue && (
// //                     <ErrorMessage>{errors.incrementValue}</ErrorMessage>
// //                   )} */}
// //                 </InputGroup>
// //               </CombineInputGroup>

// //               {/* Increment Month and Lock In Period */}
// //               <CombineInputGroup>
// //                 <InputGroup>
// //                   <Label htmlFor="incrementMonth">Increment Interval (Months)</Label>
// //                   <FieldWrappers className={
// //                     touched.incrementMonth && errors.incrementMonth
// //                       ? "border-rose-400"
// //                       : "border-gray-300"
// //                   }>
// //                     <Field
// //                       type="number"
// //                       name="incrementMonth"
// //                       id="incrementMonth"
// //                       autoComplete="off"
// //                       min="1"
// //                       max="60"
// //                       placeholder="Enter months"
// //                     //required
// //                     />
// //                   </FieldWrappers>
// //                   {/* {touched.incrementMonth && errors.incrementMonth && (
// //                     <p className="text-rose-600 text-sm">
// //                       {errors.incrementMonth}
// //                     </p>
// //                   )} */}
// //                   <div className="text-xs text-gray-500 mt-1">
// //                     Range: 1-60 months
// //                   </div>
// //                 </InputGroup>
// //                 <InputGroup>
// //                   <Label htmlFor="lockInPeriod">Lock In Period *</Label>
// //                   <FieldWrappers className={
// //                     touched.lockInPeriod && errors.lockInPeriod
// //                       ? "border-rose-400"
// //                       : "border-gray-300"
// //                   }>
// //                     <Field
// //                       type="number"
// //                       name="lockInPeriod"
// //                       id="lockInPeriod"
// //                       autoComplete="off"
// //                       min="1"
// //                       max="36"
// //                       placeholder="Enter months"
// //                     //required
// //                     />
// //                   </FieldWrappers>
// //                   {/* {touched.lockInPeriod && errors.lockInPeriod && (
// //                     <p className="text-rose-600 text-sm">
// //                       {errors.lockInPeriod}
// //                     </p>
// //                   )} */}
// //                   <div className="text-xs text-gray-500 mt-1">
// //                     Range: 1-36 months
// //                   </div>
// //                 </InputGroup>
// //               </CombineInputGroup>

// //             </Wrapper>
// //           </ScrollableContent>
// //           <ActionSection>
// //             <SideCancelBtn type="button" onClick={handleBackToStepOne}>
// //               Back
// //             </SideCancelBtn>
// //             <SubmitBtn type="submit" disabled={editLandlordLoading}>
// //               {editLandlordLoading ? "Loading..." : "Submit"}
// //             </SubmitBtn>
// //           </ActionSection>
// //         </Form>
// //       )}
// //     </Formik>
// //   );

// //   return (
// //     <Container
// //       style={{
// //         height: `${height}px`,
// //         overflow: "auto",
// //         WebkitOverflowScrolling: "touch",
// //       }}
// //     >
// //       <Header>
// //         <Title>
// //           {"Edit Landlord/Lease Details"}
// //         </Title>
// //         <button onClick={handleClose}>
// //           <MdClose color="white" size={24} />
// //         </button>
// //       </Header>
// //       <div className="px-6 h-full flex flex-col justify-between">
// //         {currentStep === 1 ? <StepOneForm /> : <StepTwoForm />}
// //       </div>
// //     </Container>
// //   );
// // };

// // // Styled components
// // const Header = tw.div`flex items-center justify-between bg-[#26A69A] py-4 px-4`;
// // const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
// // const Title = tw.h1`text-lg md:text-xl font-medium text-center text-white`;
// // const ErrorMessage = tw.div`text-red-500 text-xs mt-1`;
// // const CalenderFieldWrappers = tw.div`pl-2 rounded-md w-full flex items-center border border-gray-300 h-11`;

// // export default EditLandlordLeaseDetails;

// import React, { useState, useEffect, useRef } from "react";
// import { Formik, Field, Form } from "formik";
// import {
//   InputGroup,
//   FieldWrappers,
//   Label,
//   SubmitBtn,
//   SideCancelBtn,
//   Wrapper,
//   ScrollableContent,
//   ActionSection,
//   CombineInputGroup,
//   RupeeIcon,
//   MobileIcon,
//   ModalSubHeading,
//   ModalHeading,
//   Note,
// } from "../../Styles/InputStyles";
// import { MdClose, MdEdit } from "react-icons/md";
// import tw from "tailwind-styled-components";
// import * as Yup from "yup";
// import MenuItem from "@mui/material/MenuItem";
// import Select from "@mui/material/Select";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { FaRegCalendar } from "react-icons/fa";
// import moment from "moment";
// import { useSelector } from "react-redux";
// import { generateMonthOptions } from "../../../helpers";
// import axios from "axios";
// import Config, { ownership_roles, landlord_property_type } from "../../../Config";
// import { useQuery } from "react-query";
// import CategoryCard from "../../CategoryCard";
// import SelectItemModal from "../../SelectItemModal";
// import SelectOptionModal from "../../SelectOptionModal";

// // Step 1 Validation Schema - Updated to include ownership and propertyType
// const stepOneSchema = Yup.object().shape({
//   landlordName: Yup.string()
//     .matches(/^[A-Za-z ]+$/, "Only alphabets and spaces are allowed")
//     .min(3, "Landlord name must be at least 3 characters long")
//     .required("Landlord name is required"),
//   mobile: Yup.string()
//     .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits")
//     .required("Mobile number is required"),
//   rentPayable: Yup.number()
//     .min(1000, "Rent payable must be at least ₹1,000")
//     .max(2000000, "Rent payable cannot exceed ₹20,00,000")
//     .required("Rent payable is required"),
//   securityDeposit: Yup.number()
//     .min(0, "Security deposit cannot be negative")
//     .max(5000000, "Security deposit cannot exceed ₹50,00,000")
//     .required("Security deposit is required"),
//   agreementStartDate: Yup.date().required("Agreement start date is required"),
//   agreementEndDate: Yup.date()
//     .min(Yup.ref("agreementStartDate"), "End date must be after start date")
//     .required("Agreement end date is required"),
//   rentDate: Yup.date().required("Rent payment date is required"),
//   propertyType: Yup.number().required("Please select Property Type"),
//   ownership: Yup.number()
//     .required('Ownership Role is required'),
// });

// // Step 2 Validation Schema - Updated field names to match add modal
// const stepTwoSchema = Yup.object().shape({
//   noticePeriod: Yup.number()
//     .min(1, "Notice period must be at least 1 month")
//     .max(12, "Notice period cannot exceed 12 months")
//     .required("Notice period is required"),
//   rentCollectionType: Yup.string().required("Rent Collection Type is required"),
//   incrementMonth: Yup.number()
//     .typeError("Increment month must be a number")
//     .integer("Increment month must be a whole number")
//     .min(1, "Increment month must be at least 1 month")
//     .max(60, "Increment month cannot exceed 60 months"),
//   lockInPeriod: Yup.number()
//     .typeError("Lock-in period must be a number")
//     .integer("Lock-in period must be a whole number")
//     .min(1, "Lock-in period must be at least 1 month")
//     .max(36, "Lock-in period cannot exceed 36 months")
//     .required("Lock-in period is required"),
//   rentIncrementType: Yup.string().nullable(),
//   rentIncrementValue: Yup.number()
//     .nullable()
//     .when("rentIncrementType", {
//       is: (type) => !!type,
//       then: (schema) =>
//         schema
//           .required("Rent increment value is required")
//           .min(0, "Value cannot be negative")
//           .when("rentIncrementType", {
//             is: "2",
//             then: (s) => s.max(100, "Percentage cannot exceed 100%"),
//             otherwise: (s) =>
//               s.max(1000000, "Flat increment cannot exceed ₹10,00,000"),
//           }),
//       otherwise: (schema) => schema.notRequired(),
//     }),
// });

// const CustomDateInput = React.forwardRef(({ value, onClick, error, placeholder }, ref) => {
//   return (
//     <div
//       className={`flex items-center text-sm border rounded-md h-11 px-3 cursor-pointer ${error ? "border-rose-400" : "border-gray-300"
//         }`}
//       onClick={onClick}
//       ref={ref}
//     >
//       <span className={`flex-1 ${value ? "text-gray-800" : "text-gray-400"}`}>
//         {value || placeholder}
//       </span>
//       <FaRegCalendar className="text-gray-400" />
//     </div>
//   );
// });

// const EditLandlordLeaseDetails = ({
//   editLandlordMutate,
//   editLandlordLoading,
//   handleClose,
//   leaseData,
// }) => {
//   const [currentStep, setCurrentStep] = useState(1);
//   const [isLandlordModalOpen, setIsLandlordModalOpen] = useState(false);
//   const [selectedLandlord, setSelectedLandlord] = useState(null);
//   const [isRoleModalOpen, setIsRoleModalOpen] = useState(false);
//   const [isTypeModalOpen, setIsTypeModalOpen] = useState(false);
//   let formikRef = useRef(null);

//   const ownerRoleOptions = ownership_roles.map(role => ({
//     label: role.label,
//     value: role.value,
//   }));

//   const propertyTypeOptions = landlord_property_type.map(role => ({
//     label: role.label,
//     value: role.value,
//   }));

//   const fetchListing = async () =>
//     await axios.get(`${Config.apiUrl}/landlord/list/new`, {
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${user.token}`,
//       },
//     });

//   const { isLoading, error, data, refetch } = useQuery(
//     ["landlordData"],
//     fetchListing,
//     {
//       enabled: currentStep === 1,
//     }
//   );

//   const landlords = data?.data?.landlords;

//   const [formData, setFormData] = useState({
//     landlordName: "",
//     landlordId: "",
//     mobile: "",
//     rentPayable: "",
//     securityDeposit: "",
//     agreementStartDate: null,
//     agreementEndDate: null,
//     rentDate: null,
//     noticePeriod: "",
//     incrementMonth: "",
//     lockInPeriod: "",
//     rentIncrementType: "",
//     rentIncrementValue: "",
//     rentCollectionType: "",
//     ownership: "",
//     propertyType: "",
//   });

//   const user = useSelector((state) => state.UserReducer.user);

//   useEffect(() => {
//     if (leaseData) {
//       // Find landlord from the list if available
//       if (landlords && leaseData.landlordId) {
//         const landlord = landlords.find(l => l.id === leaseData.landlordId);
//         if (landlord) {
//           setSelectedLandlord(landlord);
//         }
//       }

//       setFormData({
//         landlordName: leaseData.landlordName || "",
//         landlordId: leaseData.landlordId || "",
//         mobile: leaseData.landlordMobile || "",
//         rentPayable: leaseData.rent || "",
//         securityDeposit: leaseData.security || "",
//         agreementStartDate: leaseData.startDate
//           ? moment(leaseData.startDate).format("YYYY-MM-DD")
//           : null,
//         agreementEndDate: leaseData.endDate
//           ? moment(leaseData.endDate).format("YYYY-MM-DD")
//           : null,
//         rentDate: leaseData.rentDate
//           ? moment(leaseData.rentDate).format("YYYY-MM-DD")
//           : null,
//         noticePeriod: leaseData.notice || "",
//         incrementMonth: leaseData.incrementMonth || "",
//         lockInPeriod: leaseData.lockInPeriod || "",
//         rentIncrementType: leaseData.incrementType?.toString() || "",
//         rentIncrementValue: leaseData.incrementValue || "",
//         rentCollectionType: leaseData.rentCollectionType?.toString() || "",
//         ownership: leaseData.ownershipType?.toString() || "",
//         propertyType: leaseData.propertyType?.toString() || ""
//       });
//     }
//   }, [leaseData, landlords]);

//   const [height, setHeight] = useState(window.innerHeight);

//   useEffect(() => {
//     const handleResize = () => {
//       setHeight(window.innerHeight);
//     };

//     window.addEventListener("resize", handleResize);
//     handleResize();

//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   // Handle landlord selection from modal
//   const handleLandlordSelect = (landlord) => {
//     if (landlord) {
//       // Update form data with selected landlord info
//       setFormData(prev => ({
//         ...prev,
//         landlordName: landlord.name || "",
//         landlordId: landlord.id || "",
//         mobile: landlord.mobile || ""
//       }));
//       setSelectedLandlord(landlord);
//     } else {
//       // Clear landlord selection
//       setFormData(prev => ({
//         ...prev,
//         landlordName: "",
//         landlordId: "",
//         mobile: ""
//       }));
//       setSelectedLandlord(null);
//     }
//   };

//   const updateFormDataOwnership = (value) => {
//     setFormData(prev => ({
//       ...prev,
//       ownership: value
//     }));
//   };

//   const updateFormDataPropertyType = (value) => {
//     setFormData(prev => ({
//       ...prev,
//       propertyType: value
//     }));
//   };

//   const handleStepOneSubmit = (values) => {
//     setFormData(prev => ({
//       ...prev,
//       ...values
//     }));
//     setCurrentStep(2);
//   };

//   const handleStepTwoSubmit = (values) => {
//     const combinedValues = {
//       ...formData,
//       ...values
//     };

//     const formattedValues = {
//       name: combinedValues.landlordName,
//       mobile: combinedValues.mobile,
//       rent: Number(combinedValues.rentPayable),
//       security: Number(combinedValues.securityDeposit),
//       startDate: combinedValues.agreementStartDate,
//       endDate: combinedValues.agreementEndDate,
//       rentDate: combinedValues.rentDate,
//       notice: combinedValues.noticePeriod,
//       propId: leaseData.propId,
//       incrementType: combinedValues.rentIncrementType,
//       incrementValue: Number(combinedValues.rentIncrementValue) || 0,
//       incrementMonth: Number(combinedValues.incrementMonth),
//       lockInPeriod: Number(combinedValues.lockInPeriod),
//       rentCollectionType: Number(combinedValues.rentCollectionType),
//       landlordId: combinedValues.landlordId,
//       ownership: Number(combinedValues.ownership),
//       propType: Number(combinedValues.propertyType)
//     };

//     editLandlordMutate(formattedValues);
//   };

//   const handleBackToStepOne = () => {
//     setCurrentStep(1);
//   };

//   const formatCurrency = (value) => {
//     if (!value && value !== 0) return "";
//     const numValue = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : value;
//     if (isNaN(numValue)) return "";
//     return new Intl.NumberFormat("en-IN").format(numValue);
//   };

//   const parseCurrency = (value) => {
//     return value.replace(/,/g, "");
//   };

//   const StepOneForm = () => (
//     <Formik
//       initialValues={formData}
//       onSubmit={handleStepOneSubmit}
//       validationSchema={stepOneSchema}
//       enableReinitialize
//       innerRef={formikRef}
//     >
//       {({ values, setFieldValue, errors, touched, handleChange }) => {
//         // Get current ownership role label
//         const getCurrentRoleLabel = () => {
//           const selectedRole = ownership_roles.find(role => role.value == values?.ownership);
//           return selectedRole ? selectedRole.label : "Select ownership role";
//         };

//         const getCurrentTypeLabel = () => {
//           const selectedType = landlord_property_type.find(role => role.value == values?.propertyType);
//           return selectedType ? selectedType.label : "Select property type";
//         };

//         const handleRoleSelect = (selectedValue) => {
//           setFieldValue("ownership", selectedValue);
//           updateFormDataOwnership(Number(selectedValue));
//         };

//         const handleTypeSelect = (selectedValue) => {
//           setFieldValue("propertyType", selectedValue);
//           updateFormDataPropertyType(Number(selectedValue));
//         };

//         return (
//           <Form>
//             <ModalSubHeading>Step 1</ModalSubHeading>
//             <ModalHeading>Basic Details</ModalHeading>
//             <ScrollableContent className="max-h-[calc(100dvh-180px)]">
//               <Wrapper>
//                 {/* Landlord Name */}
//                 <InputGroup>
//                   <Label htmlFor="landlordName">Landlord Name *</Label>
//                   {/* Show loading state */}
//                   {isLoading && (
//                     <div className="flex items-center justify-center py-4">
//                       <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
//                       <span className="ml-2 text-gray-600">
//                         Loading owner...
//                       </span>
//                     </div>
//                   )}

//                   {/* Show error state */}
//                   {error && !isLoading && (
//                     <div className="text-red-500 text-sm py-2 px-3 bg-red-50 rounded border border-red-200">
//                       Failed to load landlords. Please try again.
//                       <button
//                         onClick={() => refetch()}
//                         className="ml-2 text-blue-600 underline"
//                       >
//                         Retry
//                       </button>
//                     </div>
//                   )}

//                   {/* Show landlord dropdown when data is available */}
//                   {!isLoading && !error && data && (
//                     <CategoryCard
//                       title="Landlord"
//                       selectedCategory={selectedLandlord}
//                       onClick={() => setIsLandlordModalOpen(true)}
//                     />
//                   )}

//                   {/* Show message when no landlords found */}
//                   {!isLoading &&
//                     !error &&
//                     data &&
//                     (!landlords || landlords.length === 0) && (
//                       <div className="text-gray-500 text-sm py-2 px-3 bg-gray-50 rounded border border-gray-200">
//                         No landlord found. Please add a landlord first.
//                       </div>
//                     )}

//                   {/* Hidden field to store landlord name */}
//                   <input
//                     type="hidden"
//                     name="landlordName"
//                     value={values.landlordName}
//                     readOnly
//                   />
//                   <input
//                     type="hidden"
//                     name="landlordId"
//                     value={values.landlordId}
//                     readOnly
//                   />

//                   {errors.landlordName && touched.landlordName && (
//                     <ErrorText>{errors.landlordName}</ErrorText>
//                   )}
//                 </InputGroup>

//                 {/* Mobile Number - Readonly when landlord is selected */}
//                 <InputGroup>
//                   <Label htmlFor="mobile">Mobile Number *</Label>
//                   <FieldWrappers className={selectedLandlord ? "bg-gray-100" : ""}>
//                     <MobileIcon />
//                     <Field
//                       type="text"
//                       name="mobile"
//                       id="mobile"
//                       autoComplete="off"
//                       maxLength={10}
//                       placeholder={selectedLandlord ? "" : "Enter 10-digit mobile number"}
//                       className="w-full pl-5"
//                       readOnly
//                       value={values.mobile}
//                       onChange={handleChange}
//                     />
//                   </FieldWrappers>

//                   {errors.mobile && touched.mobile && (
//                     <ErrorText>{errors.mobile}</ErrorText>
//                   )}
//                 </InputGroup>

//                 {/* Ownership Role */}
//                 <InputGroup>
//                   <Label htmlFor="ownership">Ownership Role *</Label>
//                   <FieldWrappers onClick={() => setIsRoleModalOpen(true)}>
//                     <Field
//                       type="text"
//                       name="ownership"
//                       id="ownership"
//                       autoComplete="off"
//                       readOnly
//                       value={getCurrentRoleLabel()}
//                       className="w-full border-none outline-none bg-transparent cursor-pointer"
//                     />
//                     <MdEdit className="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 flex-shrink-0 mr-2" />
//                   </FieldWrappers>

//                   {errors.ownership && touched.ownership && (
//                     <ErrorText>{errors.ownership}</ErrorText>
//                   )}
//                 </InputGroup>

//                 {/* Property Type */}
//                 <InputGroup>
//                   <Label>Inventory Type *</Label>
//                   <FieldWrappers onClick={() => setIsTypeModalOpen(true)}>
//                     <Field
//                       type="text"
//                       name="propertyType"
//                       id="propertyType"
//                       autoComplete="off"
//                       readOnly
//                       value={getCurrentTypeLabel()}
//                       className="w-full border-none outline-none bg-transparent cursor-pointer"
//                     />
//                     <MdEdit className="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 flex-shrink-0 mr-2" />
//                   </FieldWrappers>

//                   {touched.propertyType && errors.propertyType && (
//                     <ErrorText>{errors.propertyType}</ErrorText>
//                   )}
//                 </InputGroup>

//                 <CombineInputGroup className="gap-4 md:gap-0">
//                   {/* Rent Payable */}
//                   <InputGroup>
//                     <Label htmlFor="rentPayable">Rent Payable *</Label>
//                     <FieldWrappers className={
//                       touched.rentPayable && errors.rentPayable
//                         ? "border-rose-400"
//                         : "border-gray-300"
//                     }>
//                       <RupeeIcon />
//                       <Field
//                         type="text"
//                         name="rentPayable"
//                         id="rentPayable"
//                         autoComplete="off"
//                         placeholder="Enter rent amount"
//                         value={formatCurrency(values.rentPayable)}
//                         onChange={(e) => {
//                           const rawValue = parseCurrency(e.target.value);
//                           if (rawValue === "" || /^\d+$/.test(rawValue)) {
//                             setFieldValue("rentPayable", rawValue);
//                           }
//                         }}
//                         className="w-full pl-5"
//                       />
//                     </FieldWrappers>
//                     {errors.rentPayable && touched.rentPayable && (
//                       <ErrorText>{errors.rentPayable}</ErrorText>
//                     )}
//                     <div className="text-xs text-gray-500 mt-1">
//                       Min: ₹1,000 | Max: ₹20,00,000
//                     </div>
//                   </InputGroup>

//                   {/* Security Deposit */}
//                   <InputGroup>
//                     <Label htmlFor="securityDeposit">
//                       Security Deposit *
//                     </Label>
//                     <FieldWrappers className={
//                       touched.securityDeposit && errors.securityDeposit
//                         ? "border-rose-400"
//                         : "border-gray-300"
//                     }>
//                       <RupeeIcon />
//                       <Field
//                         type="text"
//                         name="securityDeposit"
//                         id="securityDeposit"
//                         autoComplete="off"
//                         placeholder="Enter security amount"
//                         value={formatCurrency(values.securityDeposit)}
//                         onChange={(e) => {
//                           const rawValue = parseCurrency(e.target.value);
//                           if (rawValue === "" || /^\d+$/.test(rawValue)) {
//                             setFieldValue("securityDeposit", rawValue);
//                           }
//                         }}
//                         className="w-full pl-5"
//                       />
//                     </FieldWrappers>
//                     {errors.securityDeposit &&
//                       touched.securityDeposit && (
//                         <ErrorText>{errors.securityDeposit}</ErrorText>
//                       )}
//                     <div className="text-xs text-gray-500 mt-1">
//                       Min: ₹0 | Max: ₹50,00,000
//                     </div>
//                   </InputGroup>
//                 </CombineInputGroup>

//                 {/* Agreement Start Date */}
//                 <CombineInputGroup className="gap-4 md:gap-0">
//                   <InputGroup>
//                     <Label htmlFor="agreementStartDate">
//                       Agreement Start Date *
//                     </Label>
//                     <DatePicker
//                       selected={values.agreementStartDate ? new Date(values.agreementStartDate) : null}
//                       onChange={(date) =>
//                         setFieldValue(
//                           "agreementStartDate",
//                           moment(date).format("YYYY-MM-DD")
//                         )
//                       }
//                       customInput={
//                         <CustomDateInput
//                           placeholder="Select start date"
//                           error={touched.agreementStartDate && errors.agreementStartDate}
//                         />
//                       }
//                       dateFormat="yyyy-MM-dd"
//                       showMonthDropdown
//                       showYearDropdown
//                       dropdownMode="select"
//                     />
//                     {errors.agreementStartDate &&
//                       touched.agreementStartDate && (
//                         <ErrorText>{errors.agreementStartDate}</ErrorText>
//                       )}
//                   </InputGroup>

//                   {/* Agreement End Date */}
//                   <InputGroup>
//                     <Label htmlFor="agreementEndDate">
//                       Agreement End Date *
//                     </Label>
//                     <DatePicker
//                       selected={values.agreementEndDate ? new Date(values.agreementEndDate) : null}
//                       onChange={(date) =>
//                         setFieldValue(
//                           "agreementEndDate",
//                           moment(date).format("YYYY-MM-DD")
//                         )
//                       }
//                       minDate={values.agreementStartDate ? new Date(values.agreementStartDate) : null}
//                       customInput={
//                         <CustomDateInput
//                           placeholder="Select end date"
//                           error={touched.agreementEndDate && errors.agreementEndDate}
//                         />
//                       }
//                       dateFormat="yyyy-MM-dd"
//                       showMonthDropdown
//                       showYearDropdown
//                       dropdownMode="select"
//                     />
//                     {errors.agreementEndDate &&
//                       touched.agreementEndDate && (
//                         <ErrorText>{errors.agreementEndDate}</ErrorText>
//                       )}
//                   </InputGroup>
//                 </CombineInputGroup>

//                 {/* Rent Payment Date */}
//                 <InputGroup>
//                   <Label htmlFor="rentDate">
//                     Rent Payment Date *
//                   </Label>
//                   <DatePicker
//                     selected={values.rentDate ? new Date(values.rentDate) : null}
//                     onChange={(date) =>
//                       setFieldValue(
//                         "rentDate",
//                         moment(date).format("YYYY-MM-DD")
//                       )
//                     }
//                     customInput={
//                       <CustomDateInput
//                         placeholder="Select rent date"
//                         error={touched.rentDate && errors.rentDate}
//                       />
//                     }
//                     dateFormat="yyyy-MM-dd"
//                     showMonthDropdown
//                     showYearDropdown
//                     dropdownMode="select"
//                   />
//                   {errors.rentDate &&
//                     touched.rentDate && (
//                       <ErrorText>{errors.rentDate}</ErrorText>
//                     )}
//                 </InputGroup>

//               </Wrapper>
//             </ScrollableContent>
//             <ActionSection>
//               <SideCancelBtn type="button" onClick={handleClose}>
//                 Cancel
//               </SideCancelBtn>
//               <SubmitBtn type="submit">
//                 Next
//               </SubmitBtn>
//             </ActionSection>

//             {/* Landlord Selection Modal */}
//             <SelectItemModal
//               isOpen={isLandlordModalOpen}
//               onClose={() => setIsLandlordModalOpen(false)}
//               onSelect={handleLandlordSelect}
//               options={landlords || []}
//               selectedItem={selectedLandlord}
//               title="Select Landlord"
//               searchPlaceholder="Search landlord..."
//               idKey="id"
//               nameKey="name"
//               descriptionKeys={["mobile"]}
//               emptyMessage="No owners available"
//               noResultsMessage="No owners found"
//             />
//             {/* <SelectItemModal
//               isOpen={isOwnerModalOpen}
//               onClose={() => setIsOwnerModalOpen(false)}
//               onSelect={(owner) => {
//                 setSelectedOwner(owner);
//                 setFieldValue("ownerName", owner.name);
//                 setFieldValue("ownerId", owner.id);
//                 setFieldValue("mobile", owner.mobile);
//               }}
//               options={owners}
//               selectedItem={selectedOwner}
//               title="Select Owner"
//               searchPlaceholder="Search owner..."
//               idKey="id"
//               nameKey="name"
//               descriptionKeys={["mobile"]}
//             /> */}
//             <SelectOptionModal
//               isOpen={isRoleModalOpen}
//               onClose={() => setIsRoleModalOpen(false)}
//               title="Select Owner Role"
//               options={ownerRoleOptions}
//               selectedValue={values.ownership}
//               onSelect={handleRoleSelect}
//               searchPlaceholder="Search owner roles..."
//             />
//             <SelectOptionModal
//               isOpen={isTypeModalOpen}
//               onClose={() => setIsTypeModalOpen(false)}
//               title="Select Property Type"
//               options={propertyTypeOptions}
//               selectedValue={values.propertyType}
//               onSelect={handleTypeSelect}
//               searchPlaceholder="Search property type..."
//             />
//           </Form>
//         );
//       }}
//     </Formik>
//   );

//   const StepTwoForm = () => (
//     <Formik
//       initialValues={{
//         noticePeriod: formData.noticePeriod,
//         incrementMonth: formData.incrementMonth,
//         lockInPeriod: formData.lockInPeriod,
//         rentIncrementType: formData.rentIncrementType,
//         rentIncrementValue: formData.rentIncrementValue,
//         rentCollectionType: formData.rentCollectionType,
//       }}
//       onSubmit={handleStepTwoSubmit}
//       validationSchema={stepTwoSchema}
//       enableReinitialize
//     >
//       {({
//         values,
//         setFieldValue,
//         errors,
//         touched,
//       }) => (
//         <Form>
//           <ModalSubHeading>Step 2</ModalSubHeading>
//           <ModalHeading>Additional Details</ModalHeading>
//           <ScrollableContent className="max-h-[calc(100dvh-180px)]">
//             <Wrapper>

//               {/* Notice Period */}
//               <InputGroup>
//                 <Label htmlFor="noticePeriod">Notice Period *</Label>
//                 <Select
//                   name="noticePeriod"
//                   id="noticePeriod"
//                   className="w-full px-2"
//                   value={values.noticePeriod}
//                   onChange={(e) => {
//                     setFieldValue("noticePeriod", e.target.value);
//                   }}
//                   style={{ height: "46px" }}
//                   displayEmpty
//                 >
//                   <MenuItem value="" disabled>
//                     Select notice period
//                   </MenuItem>
//                   {generateMonthOptions.map((option) => (
//                     <MenuItem key={option.value} value={option.value}>
//                       {option.label}
//                     </MenuItem>
//                   ))}
//                 </Select>
//                 {errors.noticePeriod && touched.noticePeriod && (
//                   <ErrorText>{errors.noticePeriod}</ErrorText>
//                 )}
//               </InputGroup>

//               {/* Rent Collection Type */}
//               <InputGroup>
//                 <Label htmlFor="rentCollectionType">Rent Collection Type *</Label>
//                 <Select
//                   name="rentCollectionType"
//                   id="rentCollectionType"
//                   className="w-full px-2"
//                   value={values.rentCollectionType || ""}
//                   onChange={(e) => {
//                     setFieldValue("rentCollectionType", e.target.value);
//                   }}
//                   style={{ height: "46px" }}
//                   displayEmpty
//                 >
//                   <MenuItem value="" disabled>
//                     Rent Collection Type
//                   </MenuItem>
//                   <MenuItem value="1">Advance Rent</MenuItem>
//                   <MenuItem value="2">Month-End Rent</MenuItem>
//                 </Select>
//                 {errors.rentCollectionType && touched.rentCollectionType && (
//                   <ErrorText>{errors.rentCollectionType}</ErrorText>
//                 )}
//               </InputGroup>

//               {/* Rent Increment */}
//               <CombineInputGroup className="gap-4 md:gap-0">
//                 {/* Increment Type */}
//                 <InputGroup>
//                   <Label htmlFor="rentIncrementType">Rent Increment Type</Label>
//                   <Select
//                     name="rentIncrementType"
//                     id="rentIncrementType"
//                     className="w-full px-2"
//                     value={values.rentIncrementType || ""}
//                     onChange={(e) => {
//                       setFieldValue("rentIncrementType", e.target.value);
//                       setFieldValue("rentIncrementValue", "");
//                     }}
//                     style={{ height: "46px" }}
//                     displayEmpty
//                   >
//                     <MenuItem value="" disabled>
//                       Select increment type
//                     </MenuItem>
//                     <MenuItem value="1">Flat Amount (₹)</MenuItem>
//                     <MenuItem value="2">Percentage (%)</MenuItem>
//                   </Select>
//                   {errors.rentIncrementType && touched.rentIncrementType && (
//                     <ErrorText>{errors.rentIncrementType}</ErrorText>
//                   )}
//                 </InputGroup>

//                 {/* Increment Value */}
//                 <InputGroup>
//                   <Label htmlFor="rentIncrementValue">Increment Value</Label>
//                   <FieldWrappers className={
//                     touched.rentIncrementValue && errors.rentIncrementValue
//                       ? "border-rose-400"
//                       : "border-gray-300"
//                   }>
//                     {values.rentIncrementType === "2" ? (
//                       <>
//                         <Field
//                           type="number"
//                           name="rentIncrementValue"
//                           id="rentIncrementValue"
//                           min="0"
//                           max="100"
//                           placeholder="Enter % increase"
//                           className="w-full pl-2"
//                           value={values.rentIncrementValue || ""}
//                           onChange={(e) => {
//                             setFieldValue("rentIncrementValue", e.target.value);
//                           }}
//                         />
//                         <span className="text-gray-500 pr-2">%</span>
//                       </>
//                     ) : values.rentIncrementType === "1" ? (
//                       <>
//                         <RupeeIcon />
//                         <Field
//                           type="text"
//                           name="rentIncrementValue"
//                           id="rentIncrementValue"
//                           placeholder="Enter amount"
//                           value={formatCurrency(values.rentIncrementValue)}
//                           onChange={(e) => {
//                             const rawValue = parseCurrency(e.target.value);
//                             if (rawValue === "" || /^\d+$/.test(rawValue)) {
//                               setFieldValue("rentIncrementValue", rawValue);
//                             }
//                           }}
//                           className="w-full pl-5"
//                         />
//                       </>
//                     ) : (
//                       <span className="text-gray-400 text-sm pl-2 italic">
//                         Select increment type first
//                       </span>
//                     )}
//                   </FieldWrappers>
//                   {errors.rentIncrementValue && touched.rentIncrementValue && (
//                     <ErrorText>{errors.rentIncrementValue}</ErrorText>
//                   )}
//                 </InputGroup>
//               </CombineInputGroup>

//               {/* Increment Month and Lock In Period */}
//               <CombineInputGroup>
//                 <InputGroup>
//                   <Label htmlFor="incrementMonth">Increment Interval (Months)</Label>
//                   <FieldWrappers className={
//                     touched.incrementMonth && errors.incrementMonth
//                       ? "border-rose-400"
//                       : "border-gray-300"
//                   }>
//                     <Field
//                       type="number"
//                       name="incrementMonth"
//                       id="incrementMonth"
//                       autoComplete="off"
//                       min="1"
//                       max="60"
//                       placeholder="Enter months"
//                       value={values.incrementMonth || ""}
//                       onChange={(e) => {
//                         setFieldValue("incrementMonth", e.target.value);
//                       }}
//                     />
//                   </FieldWrappers>
//                   {touched.incrementMonth && errors.incrementMonth && (
//                     <ErrorText>{errors.incrementMonth}</ErrorText>
//                   )}
//                   <div className="text-xs text-gray-500 mt-1">
//                     Range: 1-60 months
//                   </div>
//                 </InputGroup>
//                 <InputGroup>
//                   <Label htmlFor="lockInPeriod">Lock In Period *</Label>
//                   <FieldWrappers className={
//                     touched.lockInPeriod && errors.lockInPeriod
//                       ? "border-rose-400"
//                       : "border-gray-300"
//                   }>
//                     <Field
//                       type="number"
//                       name="lockInPeriod"
//                       id="lockInPeriod"
//                       autoComplete="off"
//                       min="1"
//                       max="36"
//                       placeholder="Enter months"
//                       value={values.lockInPeriod || ""}
//                       onChange={(e) => {
//                         setFieldValue("lockInPeriod", e.target.value);
//                       }}
//                     />
//                   </FieldWrappers>
//                   {touched.lockInPeriod && errors.lockInPeriod && (
//                     <ErrorText>{errors.lockInPeriod}</ErrorText>
//                   )}
//                   <div className="text-xs text-gray-500 mt-1">
//                     Range: 1-36 months
//                   </div>
//                 </InputGroup>
//               </CombineInputGroup>

//             </Wrapper>
//             <div className="mt-3 flex flex-col gap-2">
//               <Note>
//                 * When you save the lease details, the system will set up a
//                 recurring rent expense. This expense will auto-generate every
//                 month as the payable rent, so you don't need to add it manually.
//               </Note>
//               <Note>
//                 * The Security Deposit will be added as a one-time payable
//                 expense.
//               </Note>
//             </div>
//           </ScrollableContent>
//           <ActionSection>
//             <SideCancelBtn type="button" onClick={handleBackToStepOne}>
//               Back
//             </SideCancelBtn>
//             <SubmitBtn type="submit" disabled={editLandlordLoading}>
//               {editLandlordLoading ? "Loading..." : "Submit"}
//             </SubmitBtn>
//           </ActionSection>
//         </Form>
//       )}
//     </Formik>
//   );

//   return (
//     <Container
//       style={{
//         height: `${height}px`,
//         overflow: "auto",
//         WebkitOverflowScrolling: "touch",
//       }}
//     >
//       <Header>
//         <Title>
//           {"Edit Lease Details"}
//         </Title>
//         <button onClick={handleClose}>
//           <MdClose color="white" size={24} />
//         </button>
//       </Header>
//       <div className="px-6 h-full flex flex-col justify-between">
//         {currentStep === 1 ? <StepOneForm /> : <StepTwoForm />}
//       </div>
//     </Container>
//   );
// };

// // Styled components
// const Header = tw.div`flex items-center justify-between bg-[#26A69A] py-4 px-4`;
// const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
// const Title = tw.h1`text-lg md:text-xl font-medium text-center text-white`;
// const ErrorText = tw.div`text-rose-600 text-xs mt-1`;

// export default EditLandlordLeaseDetails;

import React, { useState, useEffect, useRef } from "react";
import { Formik, Field, Form } from "formik";
import {
  InputGroup,
  FieldWrappers,
  Label,
  SubmitBtn,
  SideCancelBtn,
  Wrapper,
  ScrollableContent,
  ActionSection,
  CombineInputGroup,
  RupeeIcon,
  MobileIcon,
  ModalSubHeading,
  ModalHeading,
  Note,
} from "../../Styles/InputStyles";
import { MdClose, MdEdit } from "react-icons/md";
import tw from "tailwind-styled-components";
import * as Yup from "yup";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaRegCalendar } from "react-icons/fa";
import moment from "moment";
import { useSelector } from "react-redux";
import { generateMonthOptions } from "../../../helpers";
import axios from "axios";
import Config, {
  ownership_roles,
  landlord_property_type,
} from "../../../Config";
import { useQuery } from "react-query";
import CategoryCard from "../../CategoryCard";
import SelectItemModal from "../../SelectItemModal";
import SelectOptionModal from "../../SelectOptionModal";

// Step 1 Validation Schema - Updated to include ownership and inventoryType
const stepOneSchema = Yup.object().shape({
  //   landlordName: Yup.string()
  //     .matches(/^[A-Za-z ]+$/, "Only alphabets and spaces are allowed")
  //     .min(3, "Landlord name must be at least 3 characters long")
  //     .required("Landlord name is required"),
  //   mobile: Yup.string()
  //     .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits")
  //     .required("Mobile number is required"),
  rentPayable: Yup.number()
    .min(1000, "Rent payable must be at least ₹1,000")
    .max(2000000, "Rent payable cannot exceed ₹20,00,000")
    .required("Rent payable is required"),
  securityDeposit: Yup.number()
    .min(0, "Security deposit cannot be negative")
    .max(5000000, "Security deposit cannot exceed ₹50,00,000")
    .required("Security deposit is required"),
  agreementStartDate: Yup.date().required("Agreement start date is required"),
  agreementEndDate: Yup.date()
    .min(Yup.ref("agreementStartDate"), "End date must be after start date")
    .required("Agreement end date is required"),
  rentDate: Yup.date().required("Rent payment date is required"),
  //   inventoryType: Yup.number().required("Please select Property Type"),
  ownership: Yup.number().required("Ownership Role is required"),
});

// Step 2 Validation Schema - Updated field names to match add modal
const stepTwoSchema = Yup.object().shape({
  noticePeriod: Yup.number()
    .min(1, "Notice period must be at least 1 month")
    .max(12, "Notice period cannot exceed 12 months")
    .required("Notice period is required"),
  rentCollectionType: Yup.string().required("Rent Collection Type is required"),
  incrementMonth: Yup.number()
    .typeError("Increment month must be a number")
    .integer("Increment month must be a whole number")
    .min(1, "Increment month must be at least 1 month")
    .max(60, "Increment month cannot exceed 60 months"),
  lockInPeriod: Yup.number()
    .typeError("Lock-in period must be a number")
    .integer("Lock-in period must be a whole number")
    .min(1, "Lock-in period must be at least 1 month")
    .max(36, "Lock-in period cannot exceed 36 months")
    .required("Lock-in period is required"),
  rentIncrementType: Yup.string().nullable(),
  rentIncrementValue: Yup.number()
    .nullable()
    .when("rentIncrementType", {
      is: (type) => !!type,
      then: (schema) =>
        schema
          .required("Rent increment value is required")
          .min(0, "Value cannot be negative")
          .when("rentIncrementType", {
            is: "2",
            then: (s) => s.max(100, "Percentage cannot exceed 100%"),
            otherwise: (s) =>
              s.max(1000000, "Flat increment cannot exceed ₹10,00,000"),
          }),
      otherwise: (schema) => schema.notRequired(),
    }),
});

const CustomDateInput = React.forwardRef(
  ({ value, onClick, error, placeholder }, ref) => {
    return (
      <div
        className={`flex items-center text-sm border rounded-md h-11 px-3 cursor-pointer ${
          error ? "border-rose-400" : "border-gray-300"
        }`}
        onClick={onClick}
        ref={ref}
      >
        <span className={`flex-1 ${value ? "text-gray-800" : "text-gray-400"}`}>
          {value || placeholder}
        </span>
        <FaRegCalendar className="text-gray-400" />
      </div>
    );
  },
);

const EditOwnerLeaseDetails = ({
  editLandlordMutate,
  editLandlordLoading,
  handleClose,
  leaseData,
}) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [isLandlordModalOpen, setIsLandlordModalOpen] = useState(false);
  const [selectedLandlord, setSelectedLandlord] = useState(null);
  const [isRoleModalOpen, setIsRoleModalOpen] = useState(false);
  const [isTypeModalOpen, setIsTypeModalOpen] = useState(false);
  let formikRef = useRef(null);

  const ownerRoleOptions = ownership_roles.map((role) => ({
    label: role.label,
    value: role.value,
  }));

  const propertyTypeOptions = landlord_property_type.map((role) => ({
    label: role.label,
    value: role.value,
  }));

  const fetchListing = async () =>
    await axios.get(`${Config.apiUrl}/landlord/list/new`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user.token}`,
      },
    });

  const { isLoading, error, data, refetch } = useQuery(
    ["landlordData"],
    // fetchListing,
    // {
    //   enabled: currentStep === 1,
    // }
  );

  const landlords = data?.data?.landlords;

  const [formData, setFormData] = useState({
    landlordName: "",
    landlordId: "",
    mobile: "",
    rentPayable: "",
    securityDeposit: "",
    agreementStartDate: null,
    agreementEndDate: null,
    rentDate: null,
    noticePeriod: "",
    incrementMonth: "",
    lockInPeriod: "",
    rentIncrementType: "",
    rentIncrementValue: "",
    rentCollectionType: "",
    ownership: "",
    inventoryType: "",
  });

  const user = useSelector((state) => state.UserReducer.user);

  useEffect(() => {
    if (leaseData) {
      // Find landlord from the list if available
      if (landlords && leaseData.landlordId) {
        const landlord = landlords.find((l) => l.id === leaseData.landlordId);
        if (landlord) {
          setSelectedLandlord(landlord);
        }
      }

      setFormData({
        landlordName: leaseData.landlordName || "",
        landlordId: leaseData.landlordId || "",
        mobile: leaseData.landlordMobile || "",
        rentPayable: leaseData.rent || "",
        securityDeposit: leaseData.security || "",
        agreementStartDate: leaseData.startDate
          ? moment(leaseData.startDate).format("YYYY-MM-DD")
          : null,
        agreementEndDate: leaseData.endDate
          ? moment(leaseData.endDate).format("YYYY-MM-DD")
          : null,
        rentDate: leaseData.rentDate
          ? moment(leaseData.rentDate).format("YYYY-MM-DD")
          : null,
        noticePeriod: leaseData.notice || "",
        incrementMonth: leaseData.incrementMonth || "",
        lockInPeriod: leaseData.lockInPeriod || "",
        rentIncrementType: leaseData.incrementType?.toString() || "",
        rentIncrementValue: leaseData.incrementValue || "",
        rentCollectionType: leaseData.rentCollectionType?.toString() || "",
        ownership: leaseData.ownershipType?.toString() || "",
        inventoryType: leaseData.inventoryType?.toString() || "",
      });
    }
  }, [leaseData, landlords]);

  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Handle landlord selection from modal
  const handleLandlordSelect = (landlord) => {
    if (landlord) {
      // Update form data with selected landlord info
      setFormData((prev) => ({
        ...prev,
        landlordName: landlord.name || "",
        landlordId: landlord.id || "",
        mobile: landlord.mobile || "",
      }));
      setSelectedLandlord(landlord);
    } else {
      // Clear landlord selection
      setFormData((prev) => ({
        ...prev,
        landlordName: "",
        landlordId: "",
        mobile: "",
      }));
      setSelectedLandlord(null);
    }
  };

  const updateFormDataOwnership = (value) => {
    setFormData((prev) => ({
      ...prev,
      ownership: value,
    }));
  };

  const updateFormDataPropertyType = (value) => {
    setFormData((prev) => ({
      ...prev,
      inventoryType: value,
    }));
  };

  const handleStepOneSubmit = (values) => {
    setFormData((prev) => ({
      ...prev,
      ...values,
    }));
    setCurrentStep(2);
  };

  const handleStepTwoSubmit = (values) => {
    const combinedValues = {
      ...formData,
      ...values,
    };

    const formattedValues = {
      name: combinedValues.landlordName,
      mobile: combinedValues.mobile,
      rent: Number(combinedValues.rentPayable),
      security: Number(combinedValues.securityDeposit),
      startDate: combinedValues.agreementStartDate,
      endDate: combinedValues.agreementEndDate,
      rentDate: combinedValues.rentDate,
      notice: combinedValues.noticePeriod,
      inventoryId: leaseData.inventoryId,
      incrementType: combinedValues.rentIncrementType,
      incrementValue: Number(combinedValues.rentIncrementValue) || 0,
      incrementMonth: Number(combinedValues.incrementMonth),
      lockInPeriod: Number(combinedValues.lockInPeriod),
      rentCollectionType: Number(combinedValues.rentCollectionType),
      landlordId: combinedValues.landlordId,
      ownership: Number(combinedValues.ownership),
      inventoryType: Number(combinedValues.inventoryType),
    };

    editLandlordMutate(formattedValues);
  };

  const handleBackToStepOne = () => {
    setCurrentStep(1);
  };

  const formatCurrency = (value) => {
    if (!value && value !== 0) return "";
    const numValue =
      typeof value === "string" ? parseFloat(value.replace(/,/g, "")) : value;
    if (isNaN(numValue)) return "";
    return new Intl.NumberFormat("en-IN").format(numValue);
  };

  const parseCurrency = (value) => {
    return value.replace(/,/g, "");
  };

  const StepOneForm = () => (
    <Formik
      initialValues={formData}
      onSubmit={handleStepOneSubmit}
      validationSchema={stepOneSchema}
      enableReinitialize
      innerRef={formikRef}
    >
      {({ values, setFieldValue, errors, touched, handleChange }) => {
        // Get current ownership role label
        const getCurrentRoleLabel = () => {
          const selectedRole = ownership_roles.find(
            (role) => role.value == values?.ownership,
          );
          return selectedRole ? selectedRole.label : "Select ownership role";
        };

        const getCurrentTypeLabel = () => {
          const selectedType = landlord_property_type.find(
            (role) => role.value == values?.inventoryType,
          );
          return selectedType ? selectedType.label : "Select property type";
        };

        const handleRoleSelect = (selectedValue) => {
          setFieldValue("ownership", selectedValue);
          updateFormDataOwnership(Number(selectedValue));
        };

        const handleTypeSelect = (selectedValue) => {
          setFieldValue("inventoryType", selectedValue);
          updateFormDataPropertyType(Number(selectedValue));
        };

        return (
          <Form>
            <ModalSubHeading>Step 1</ModalSubHeading>
            <ModalHeading>Basic Details</ModalHeading>
            <ScrollableContent className="max-h-[calc(100dvh-180px)]">
              <Wrapper>
                {/* Landlord Name */}
                {/* <InputGroup>
                  <Label htmlFor="landlordName">Landlord Name *</Label>
                  {isLoading && (
                    <div className="flex items-center justify-center py-4">
                      <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
                      <span className="ml-2 text-gray-600">
                        Loading owner...
                      </span>
                    </div>
                  )}

                  {error && !isLoading && (
                    <div className="text-red-500 text-sm py-2 px-3 bg-red-50 rounded border border-red-200">
                      Failed to load landlords. Please try again.
                      <button
                        onClick={() => refetch()}
                        className="ml-2 text-blue-600 underline"
                      >
                        Retry
                      </button>
                    </div>
                  )}

                  {!isLoading && !error && data && (
                    <CategoryCard
                      title="Landlord"
                      selectedCategory={selectedLandlord}
                      onClick={() => setIsLandlordModalOpen(true)}
                    />
                  )}

                  {!isLoading &&
                    !error &&
                    data &&
                    (!landlords || landlords.length === 0) && (
                      <div className="text-gray-500 text-sm py-2 px-3 bg-gray-50 rounded border border-gray-200">
                        No landlord found. Please add a landlord first.
                      </div>
                    )}

                  <input
                    type="hidden"
                    name="landlordName"
                    value={values.landlordName}
                    readOnly
                  />
                  <input
                    type="hidden"
                    name="landlordId"
                    value={values.landlordId}
                    readOnly
                  />

                  {errors.landlordName && touched.landlordName && (
                    <ErrorText>{errors.landlordName}</ErrorText>
                  )}
                </InputGroup> */}

                {/* Mobile Number - Readonly when landlord is selected */}
                {/* <InputGroup>
                  <Label htmlFor="mobile">Mobile Number *</Label>
                  <FieldWrappers className={selectedLandlord ? "bg-gray-100" : ""}>
                    <MobileIcon />
                    <Field
                      type="text"
                      name="mobile"
                      id="mobile"
                      autoComplete="off"
                      maxLength={10}
                      placeholder={selectedLandlord ? "" : "Enter 10-digit mobile number"}
                      className="w-full pl-5"
                      readOnly
                      value={values.mobile}
                      onChange={handleChange}
                    />
                  </FieldWrappers>

                  {errors.mobile && touched.mobile && (
                    <ErrorText>{errors.mobile}</ErrorText>
                  )}
                </InputGroup> */}

                {/* Ownership Role */}
                <InputGroup>
                  <Label htmlFor="ownership">Ownership Role *</Label>
                  <FieldWrappers onClick={() => setIsRoleModalOpen(true)}>
                    <Field
                      type="text"
                      name="ownership"
                      id="ownership"
                      autoComplete="off"
                      readOnly
                      value={getCurrentRoleLabel()}
                      className="w-full border-none outline-none bg-transparent cursor-pointer"
                    />
                    <MdEdit className="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 flex-shrink-0 mr-2" />
                  </FieldWrappers>

                  {errors.ownership && touched.ownership && (
                    <ErrorText>{errors.ownership}</ErrorText>
                  )}
                </InputGroup>

                {/* Property Type */}
                {/* <InputGroup>
                  <Label>Inventory Type *</Label>
                  <FieldWrappers onClick={() => setIsTypeModalOpen(true)}>
                    <Field
                      type="text"
                      name="inventoryType"
                      id="inventoryType"
                      autoComplete="off"
                      readOnly
                      value={getCurrentTypeLabel()}
                      className="w-full border-none outline-none bg-transparent cursor-pointer"
                    />
                    <MdEdit className="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 flex-shrink-0 mr-2" />
                  </FieldWrappers>

                  {touched.inventoryType && errors.inventoryType && (
                    <ErrorText>{errors.inventoryType}</ErrorText>
                  )}
                </InputGroup> */}

                <CombineInputGroup className="gap-4 md:gap-0">
                  {/* Rent Payable */}
                  <InputGroup>
                    <Label htmlFor="rentPayable">Rent Payable *</Label>
                    <FieldWrappers
                      className={
                        touched.rentPayable && errors.rentPayable
                          ? "border-rose-400"
                          : "border-gray-300"
                      }
                    >
                      <RupeeIcon />
                      <Field
                        type="text"
                        name="rentPayable"
                        id="rentPayable"
                        autoComplete="off"
                        placeholder="Enter rent amount"
                        value={formatCurrency(values.rentPayable)}
                        onChange={(e) => {
                          const rawValue = parseCurrency(e.target.value);
                          if (rawValue === "" || /^\d+$/.test(rawValue)) {
                            setFieldValue("rentPayable", rawValue);
                          }
                        }}
                        className="w-full pl-5"
                      />
                    </FieldWrappers>
                    {errors.rentPayable && touched.rentPayable && (
                      <ErrorText>{errors.rentPayable}</ErrorText>
                    )}
                    <div className="text-xs text-gray-500 mt-1">
                      Min: ₹1,000 | Max: ₹20,00,000
                    </div>
                  </InputGroup>

                  {/* Security Deposit */}
                  <InputGroup>
                    <Label htmlFor="securityDeposit">Security Deposit *</Label>
                    <FieldWrappers
                      className={
                        touched.securityDeposit && errors.securityDeposit
                          ? "border-rose-400"
                          : "border-gray-300"
                      }
                    >
                      <RupeeIcon />
                      <Field
                        type="text"
                        name="securityDeposit"
                        id="securityDeposit"
                        autoComplete="off"
                        placeholder="Enter security amount"
                        value={formatCurrency(values.securityDeposit)}
                        onChange={(e) => {
                          const rawValue = parseCurrency(e.target.value);
                          if (rawValue === "" || /^\d+$/.test(rawValue)) {
                            setFieldValue("securityDeposit", rawValue);
                          }
                        }}
                        className="w-full pl-5"
                      />
                    </FieldWrappers>
                    {errors.securityDeposit && touched.securityDeposit && (
                      <ErrorText>{errors.securityDeposit}</ErrorText>
                    )}
                    <div className="text-xs text-gray-500 mt-1">
                      Min: ₹0 | Max: ₹50,00,000
                    </div>
                  </InputGroup>
                </CombineInputGroup>

                {/* Agreement Start Date */}
                <CombineInputGroup className="gap-4 md:gap-0">
                  <InputGroup>
                    <Label htmlFor="agreementStartDate">
                      Agreement Start Date *
                    </Label>
                    <DatePicker
                      selected={
                        values.agreementStartDate
                          ? new Date(values.agreementStartDate)
                          : null
                      }
                      onChange={(date) =>
                        setFieldValue(
                          "agreementStartDate",
                          moment(date).format("YYYY-MM-DD"),
                        )
                      }
                      customInput={
                        <CustomDateInput
                          placeholder="Select start date"
                          error={
                            touched.agreementStartDate &&
                            errors.agreementStartDate
                          }
                        />
                      }
                      dateFormat="yyyy-MM-dd"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                    />
                    {errors.agreementStartDate &&
                      touched.agreementStartDate && (
                        <ErrorText>{errors.agreementStartDate}</ErrorText>
                      )}
                  </InputGroup>

                  {/* Agreement End Date */}
                  <InputGroup>
                    <Label htmlFor="agreementEndDate">
                      Agreement End Date *
                    </Label>
                    <DatePicker
                      selected={
                        values.agreementEndDate
                          ? new Date(values.agreementEndDate)
                          : null
                      }
                      onChange={(date) =>
                        setFieldValue(
                          "agreementEndDate",
                          moment(date).format("YYYY-MM-DD"),
                        )
                      }
                      minDate={
                        values.agreementStartDate
                          ? new Date(values.agreementStartDate)
                          : null
                      }
                      customInput={
                        <CustomDateInput
                          placeholder="Select end date"
                          error={
                            touched.agreementEndDate && errors.agreementEndDate
                          }
                        />
                      }
                      dateFormat="yyyy-MM-dd"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                    />
                    {errors.agreementEndDate && touched.agreementEndDate && (
                      <ErrorText>{errors.agreementEndDate}</ErrorText>
                    )}
                  </InputGroup>
                </CombineInputGroup>

                {/* Rent Payment Date */}
                <InputGroup>
                  <Label htmlFor="rentDate">Rent Payment Date *</Label>
                  <DatePicker
                    selected={
                      values.rentDate ? new Date(values.rentDate) : null
                    }
                    onChange={(date) =>
                      setFieldValue(
                        "rentDate",
                        moment(date).format("YYYY-MM-DD"),
                      )
                    }
                    customInput={
                      <CustomDateInput
                        placeholder="Select rent date"
                        error={touched.rentDate && errors.rentDate}
                      />
                    }
                    dateFormat="yyyy-MM-dd"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                  {errors.rentDate && touched.rentDate && (
                    <ErrorText>{errors.rentDate}</ErrorText>
                  )}
                </InputGroup>
              </Wrapper>
            </ScrollableContent>
            <ActionSection>
              <SideCancelBtn type="button" onClick={handleClose}>
                Cancel
              </SideCancelBtn>
              <SubmitBtn type="submit">Next</SubmitBtn>
            </ActionSection>

            {/* Landlord Selection Modal */}
            <SelectItemModal
              isOpen={isLandlordModalOpen}
              onClose={() => setIsLandlordModalOpen(false)}
              onSelect={handleLandlordSelect}
              options={landlords || []}
              selectedItem={selectedLandlord}
              title="Select Landlord"
              searchPlaceholder="Search landlord..."
              idKey="id"
              nameKey="name"
              descriptionKeys={["mobile"]}
              emptyMessage="No owners available"
              noResultsMessage="No owners found"
            />
            {/* <SelectItemModal
              isOpen={isOwnerModalOpen}
              onClose={() => setIsOwnerModalOpen(false)}
              onSelect={(owner) => {
                setSelectedOwner(owner);
                setFieldValue("ownerName", owner.name);
                setFieldValue("ownerId", owner.id);
                setFieldValue("mobile", owner.mobile);
              }}
              options={owners}
              selectedItem={selectedOwner}
              title="Select Owner"
              searchPlaceholder="Search owner..."
              idKey="id"
              nameKey="name"
              descriptionKeys={["mobile"]}
            /> */}
            <SelectOptionModal
              isOpen={isRoleModalOpen}
              onClose={() => setIsRoleModalOpen(false)}
              title="Select Owner Role"
              options={ownerRoleOptions}
              selectedValue={values.ownership}
              onSelect={handleRoleSelect}
              searchPlaceholder="Search owner roles..."
            />
            <SelectOptionModal
              isOpen={isTypeModalOpen}
              onClose={() => setIsTypeModalOpen(false)}
              title="Select Inventory Type"
              options={propertyTypeOptions}
              selectedValue={values.inventoryType}
              onSelect={handleTypeSelect}
              searchPlaceholder="Search inventory type..."
            />
          </Form>
        );
      }}
    </Formik>
  );

  const StepTwoForm = () => (
    <Formik
      initialValues={{
        noticePeriod: formData.noticePeriod,
        incrementMonth: formData.incrementMonth,
        lockInPeriod: formData.lockInPeriod,
        rentIncrementType: formData.rentIncrementType,
        rentIncrementValue: formData.rentIncrementValue,
        rentCollectionType: formData.rentCollectionType,
      }}
      onSubmit={handleStepTwoSubmit}
      validationSchema={stepTwoSchema}
      enableReinitialize
    >
      {({ values, setFieldValue, errors, touched }) => (
        <Form>
          <ModalSubHeading>Step 2</ModalSubHeading>
          <ModalHeading>Additional Details</ModalHeading>
          <ScrollableContent className="max-h-[calc(100dvh-180px)]">
            <Wrapper>
              {/* Notice Period */}
              <InputGroup>
                <Label htmlFor="noticePeriod">Notice Period *</Label>
                <Select
                  name="noticePeriod"
                  id="noticePeriod"
                  className="w-full px-2"
                  value={values.noticePeriod}
                  onChange={(e) => {
                    setFieldValue("noticePeriod", e.target.value);
                  }}
                  style={{ height: "46px" }}
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    Select notice period
                  </MenuItem>
                  {generateMonthOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
                {errors.noticePeriod && touched.noticePeriod && (
                  <ErrorText>{errors.noticePeriod}</ErrorText>
                )}
              </InputGroup>

              {/* Rent Collection Type */}
              <InputGroup>
                <Label htmlFor="rentCollectionType">
                  Rent Collection Type *
                </Label>
                <Select
                  name="rentCollectionType"
                  id="rentCollectionType"
                  className="w-full px-2"
                  value={values.rentCollectionType || ""}
                  onChange={(e) => {
                    setFieldValue("rentCollectionType", e.target.value);
                  }}
                  style={{ height: "46px" }}
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    Rent Collection Type
                  </MenuItem>
                  <MenuItem value="1">Advance Rent</MenuItem>
                  <MenuItem value="2">Month-End Rent</MenuItem>
                </Select>
                {errors.rentCollectionType && touched.rentCollectionType && (
                  <ErrorText>{errors.rentCollectionType}</ErrorText>
                )}
              </InputGroup>

              {/* Rent Increment */}
              <CombineInputGroup className="gap-4 md:gap-0">
                {/* Increment Type */}
                <InputGroup>
                  <Label htmlFor="rentIncrementType">Rent Increment Type</Label>
                  <Select
                    name="rentIncrementType"
                    id="rentIncrementType"
                    className="w-full px-2"
                    value={values.rentIncrementType || ""}
                    onChange={(e) => {
                      setFieldValue("rentIncrementType", e.target.value);
                      setFieldValue("rentIncrementValue", "");
                    }}
                    style={{ height: "46px" }}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select increment type
                    </MenuItem>
                    <MenuItem value="1">Flat Amount (₹)</MenuItem>
                    <MenuItem value="2">Percentage (%)</MenuItem>
                  </Select>
                  {errors.rentIncrementType && touched.rentIncrementType && (
                    <ErrorText>{errors.rentIncrementType}</ErrorText>
                  )}
                </InputGroup>

                {/* Increment Value */}
                <InputGroup>
                  <Label htmlFor="rentIncrementValue">Increment Value</Label>
                  <FieldWrappers
                    className={
                      touched.rentIncrementValue && errors.rentIncrementValue
                        ? "border-rose-400"
                        : "border-gray-300"
                    }
                  >
                    {values.rentIncrementType === "2" ? (
                      <>
                        <Field
                          type="number"
                          name="rentIncrementValue"
                          id="rentIncrementValue"
                          min="0"
                          max="100"
                          placeholder="Enter % increase"
                          className="w-full pl-2"
                          value={values.rentIncrementValue || ""}
                          onChange={(e) => {
                            setFieldValue("rentIncrementValue", e.target.value);
                          }}
                        />
                        <span className="text-gray-500 pr-2">%</span>
                      </>
                    ) : values.rentIncrementType === "1" ? (
                      <>
                        <RupeeIcon />
                        <Field
                          type="text"
                          name="rentIncrementValue"
                          id="rentIncrementValue"
                          placeholder="Enter amount"
                          value={formatCurrency(values.rentIncrementValue)}
                          onChange={(e) => {
                            const rawValue = parseCurrency(e.target.value);
                            if (rawValue === "" || /^\d+$/.test(rawValue)) {
                              setFieldValue("rentIncrementValue", rawValue);
                            }
                          }}
                          className="w-full pl-5"
                        />
                      </>
                    ) : (
                      <span className="text-gray-400 text-sm pl-2 italic">
                        Select increment type first
                      </span>
                    )}
                  </FieldWrappers>
                  {errors.rentIncrementValue && touched.rentIncrementValue && (
                    <ErrorText>{errors.rentIncrementValue}</ErrorText>
                  )}
                </InputGroup>
              </CombineInputGroup>

              {/* Increment Month and Lock In Period */}
              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="incrementMonth">
                    Increment Interval (Months)
                  </Label>
                  <FieldWrappers
                    className={
                      touched.incrementMonth && errors.incrementMonth
                        ? "border-rose-400"
                        : "border-gray-300"
                    }
                  >
                    <Field
                      type="number"
                      name="incrementMonth"
                      id="incrementMonth"
                      autoComplete="off"
                      min="1"
                      max="60"
                      placeholder="Enter months"
                      value={values.incrementMonth || ""}
                      onChange={(e) => {
                        setFieldValue("incrementMonth", e.target.value);
                      }}
                    />
                  </FieldWrappers>
                  {touched.incrementMonth && errors.incrementMonth && (
                    <ErrorText>{errors.incrementMonth}</ErrorText>
                  )}
                  <div className="text-xs text-gray-500 mt-1">
                    Range: 1-60 months
                  </div>
                </InputGroup>
                <InputGroup>
                  <Label htmlFor="lockInPeriod">Lock In Period *</Label>
                  <FieldWrappers
                    className={
                      touched.lockInPeriod && errors.lockInPeriod
                        ? "border-rose-400"
                        : "border-gray-300"
                    }
                  >
                    <Field
                      type="number"
                      name="lockInPeriod"
                      id="lockInPeriod"
                      autoComplete="off"
                      min="1"
                      max="36"
                      placeholder="Enter months"
                      value={values.lockInPeriod || ""}
                      onChange={(e) => {
                        setFieldValue("lockInPeriod", e.target.value);
                      }}
                    />
                  </FieldWrappers>
                  {touched.lockInPeriod && errors.lockInPeriod && (
                    <ErrorText>{errors.lockInPeriod}</ErrorText>
                  )}
                  <div className="text-xs text-gray-500 mt-1">
                    Range: 1-36 months
                  </div>
                </InputGroup>
              </CombineInputGroup>
            </Wrapper>
            <div className="mt-3 flex flex-col gap-2">
              <Note>
                * When you save the lease details, the system will set up a
                recurring rent expense. This expense will auto-generate every
                month as the payable rent, so you don't need to add it manually.
              </Note>
              <Note>
                * The Security Deposit will be added as a one-time payable
                expense.
              </Note>
            </div>
          </ScrollableContent>
          <ActionSection>
            <SideCancelBtn type="button" onClick={handleBackToStepOne}>
              Back
            </SideCancelBtn>
            <SubmitBtn type="submit" disabled={editLandlordLoading}>
              {editLandlordLoading ? "Loading..." : "Submit"}
            </SubmitBtn>
          </ActionSection>
        </Form>
      )}
    </Formik>
  );

  return (
    <Container
      style={{
        height: `${height}px`,
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <Header>
        <Title>{"Edit Lease Details"}</Title>
        <button onClick={handleClose}>
          <MdClose color="white" size={24} />
        </button>
      </Header>
      <div className="px-6 h-full flex flex-col justify-between">
        {currentStep === 1 ? <StepOneForm /> : <StepTwoForm />}
      </div>
    </Container>
  );
};

// Styled components
const Header = tw.div`flex items-center justify-between bg-gradient-to-r from-primary-color to-teal-400 py-4 px-4`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-white`;
const ErrorText = tw.div`text-rose-600 text-xs mt-1`;

export default EditOwnerLeaseDetails;
